// We enforce not to import MUI `Alert` so all Alert
// components will use this component. Thus we need to disable the lint rule.
// eslint-disable-next-line no-restricted-imports
import { Alert as MuiAlert, AlertProps } from '@material-ui/lab';
import { css } from '@emotion/react';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
// import { colors } from 'styles/theme';
import { setOpacity } from 'styles/utils';

const muiAlertCss = (colors: IColors) => css`
	&.MuiAlert-root {
		padding: 10px;
		font-size: 1.8rem;
		justify-content: center;
		border-radius: 7px;

		.MuiAlert-message {
			padding: 0;
			text-align: center;
		}

		/* Error */
		&.MuiAlert-standardError {
			color: ${colors.tx_error};
			background-color: ${setOpacity(colors.bg_error || '', 0.1)};
		}

		/* Success */
		&.MuiAlert-standardSuccess {
			color: ${colors.successGreenText};
			background-color: ${setOpacity(colors.successGreenBg || '', 0.1)};
		}
	}
`;

/**
 * Material UI Alert wrapper.
 *
 * An alert displays a short, important message in a way that
 * attracts the user's attention without interrupting the user's task.
 *
 * @see
 * [Alert](https://material-ui.com/components/alert)
 * @see
 * [Alert API](https://material-ui.com/api/alert)
 */
function Alert({ children, ...restProps }: AlertProps) {
	const { colors } = useColors();
	return (
		<MuiAlert icon={false} css={muiAlertCss(colors)} {...restProps}>
			{children}
		</MuiAlert>
	);
}

export default Alert;
